import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  computed,
  input,
  output
} from '@angular/core';
import { CHIP_HOST } from './chip.constants';
import { ChipAppearance, ChipSize } from './chip.models';
import { Color } from '~ui-kit/core';

@Component({
  selector: 'button[chip], span[chip], div[chip]',
  standalone: true,
  imports: [],
  host: CHIP_HOST,
  template: ` <span class="chip__label"><ng-content></ng-content></span>
    @if (dismissible()) {
      <span class="chip__dismiss" (click)="_emitDismiss()">
        @if (appearance() === 'outlined') {
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
            <rect width="15" height="15" rx="7.5" fill="currentColor" />
            <path
              id="close"
              d="M3.55,3.136,5.886.8a.389.389,0,0,0-.55-.55L3,2.586.664.25A.389.389,0,0,0,.114.8L2.45,3.136.114,5.473a.389.389,0,1,0,.55.55L3,3.686,5.337,6.022a.389.389,0,1,0,.55-.55Zm0,0"
              transform="translate(4.5 4.864)"
              fill="currentColor"
            />
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
            <g fill="none" stroke="currentColor" stroke-width="1">
              <rect width="15" height="15" rx="7.5" stroke="none"></rect>
              <rect
                x="0.5"
                y="0.5"
                width="14"
                height="14"
                rx="7"
                fill="none"
              ></rect>
            </g>
            <path
              id="close"
              d="M3.55,3.136,5.886.8a.389.389,0,0,0-.55-.55L3,2.586.664.25A.389.389,0,0,0,.114.8L2.45,3.136.114,5.473a.389.389,0,1,0,.55.55L3,3.686,5.337,6.022a.389.389,0,1,0,.55-.55Zm0,0"
              transform="translate(4.5 4.864)"
              fill="currentColor"
            ></path>
          </svg>
        }
      </span>
    }`,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipComponent {
  appearance = input<ChipAppearance>('filled');
  color = input<Color>('primary');
  size = input<ChipSize>('md');
  dismissible = input<boolean>(false);

  dismissed = output<void>();

  protected classList = computed(
    () =>
      `chip chip--${this.appearance()} chip--${this.color()} chip--${this.size()}`
  );

  protected dismissibleAttributeStatus = computed(() =>
    this.dismissible() ? true : null
  );

  protected _emitDismiss(): void {
    if (this.dismissible()) {
      this.dismissed.emit();
    }
  }
}
